module.exports = __webpack_public_path__ + "img/kdLogoTop.06f59bed.png";